var _path, _path2, _path3, _path4, _path5, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoVisibility(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    height: 512,
    viewBox: "0 0 60 60",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m52 43v14a2.006 2.006 0 0 1 -2 2h-40a2.006 2.006 0 0 1 -2-2v-14l1-1h42z",
    fill: "#f23d4a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m52 14v29h-44v-40a2.006 2.006 0 0 1 2-2h29a1.275 1.275 0 0 1 .2.01 4.511 4.511 0 0 1 3.2 1.39l8.2 8.2a4.511 4.511 0 0 1 1.39 3.2 1.275 1.275 0 0 1 .01.2z",
    fill: "#e8edf3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m51.99 13.8a2.006 2.006 0 0 0 -1.99-1.8h-6a3 3 0 0 1 -3-3v-6a2.006 2.006 0 0 0 -1.8-1.99 4.511 4.511 0 0 1 3.2 1.39l8.2 8.2a4.511 4.511 0 0 1 1.39 3.2z",
    fill: "#bfcedd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m22 36h-7a2 2 0 0 1 -2-2v-14a2 2 0 0 1 2-2h7z",
    fill: "#99afc1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m38 18h7a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-7z",
    fill: "#99afc1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#bfcedd",
    height: 22,
    rx: 2,
    width: 20,
    x: 20,
    y: 16
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21 46h-3a1 1 0 0 0 -1 1v8a1 1 0 0 0 2 0v-3h2a3 3 0 0 0 0-6zm0 4h-2v-2h2a1 1 0 0 1 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 46h-3a1 1 0 0 0 -1 1v8a1 1 0 0 0 2 0v-3h2a3 3 0 0 0 0-6zm0 4h-2v-2h2a1 1 0 0 1 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 46h-6a1 1 0 0 0 0 2h2v7a1 1 0 0 0 2 0v-7h2a1 1 0 0 0 0-2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoVisibility);
export default __webpack_public_path__ + "static/media/no-visibility.2d4d05e72271cdb85658081550c16df1.svg";
export { ForwardRef as ReactComponent };